<template>
    <div class="image-card">
        <!-- Card Header -->
        <div class="card-header">
            <span>
                <i :class="getFeatureIcons(this.type)"></i> {{ getFeatureNames(this.type) }}
            </span>
        </div>

        <!-- Card Body -->
        <div class="card-body">
            <span v-if="type === 'trading_view'">
                <span class="highlight">
                    <i class="fas fa-chart-simple"></i>
                </span>
            </span>
            <span v-if="type === 'management'">
                <span class="highlight">
                    <i class="fas fa-users-gear"></i>
                </span>
            </span>
            <span v-if="mos">
                <span class="highlight" :class="{'trans-ceil' : mos >= 0.5, 
                                                'trans-positive' : mos >= 0.3 & mos < 0.5, 
                                                'trans-neutral' : mos >= 0 & mos < 0.3,
                                                'trans-negative': mos < 0 }">
                    {{ mos | percentDisplay }} 
                </span>
            </span>
            <span v-if="dca">
                <span class="highlight" :class="{'trans-ceil' : dca >= 7.5, 
                                                'trans-positive' : dca >= 5 & dca < 7.5, 
                                                'trans-negative': dca < 5 }">
                    {{ dca / 10 | percentDisplay}}
                </span>
            </span>
            <span v-if="competitors">
                <span class="highlight">
                    {{ competitors }}
                </span>
            </span>
            <span v-if="dividend > -1">
                <div class="highlight" :class="{
                    'trans-ceil': dividend * 100 >= 7.5,
                    'trans-positive': dividend * 100 >= 5 & dividend * 100 < 7.5,
                    'trans-neutral': dividend * 100 < 5
                }">
                    {{ dividend | percentDisplay }}
                </div>
            </span>
        </div>

        <!-- Card Footer with Button -->
        <div class="card-footer">
             <span v-if="type === 'dividend'">
                <button @click="viewDetails" class="details-btn">View basic information</button>
             </span>
             <span v-else>
                <button @click="viewDetails" class="details-btn">View More</button>
             </span>
        </div>
    </div>
</template>

<script>
import common from "@/libs/common";

export default {
    props: {
        type: {
            type: String,
            default: 'financial_ratios'
        },
        mos: 0,
        dca: 0,
        dividend: 0,
        competitors: {
            type: Number,
            default: 0
        }
    },
    methods: {
        getFeatureNames(feature) {
            return common.getFeatureNames(feature);
        },
        getFeatureIcons(feature) {
            return common.getFeatureIcons(feature);
        },
        viewDetails() {
            this.$emit('view-details', this.type);
        }
    }
};
</script>

<style scoped>
/* Card styling */
.image-card {
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    padding: 2px;
    max-width: 300px;
    background-color: var(--white);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

/* Header styling */
.card-header h3 {
    margin: 0;
    font-size: 16px;
    font-weight: bold;
    color: #333;
}

/* Body styling */
.card-body {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin: 10px 0;
}

/* Footer styling */
.card-footer {
    display: flex;
    justify-content: flex-end;
}

.highlight {
    font-size: 32px;
}

/* Button styling */
.details-btn {
    background-color: transparent;
    color: var(--blue);
    border: none;
    padding: 8px 12px;
    cursor: pointer;
    border-radius: 4px;
    font-size: 14px;
}

.details-btn:hover {
    background-color: var(--light);
}
</style>